// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W6aKh","colMin":"styles_colMin__qkl2E"};